import React, { useState } from "react";
import { Tab, Nav } from 'react-bootstrap';
import AgencyListTable from './AgencyListTable';
import * as HELPER from '@src/config/helper';
import { PAGE_NUMBER, ROLE_FEATURES } from '@src/config/constant';
import { useNavigate } from 'react-router-dom';
import AgencyListTopFilter from './AgencyListTopFilter';
import { INS_INSURANCE_ID_STAGE } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";
import Modal from "@src/common/ModalPopup";
import BulkImportModal from "@src/component/rule-engine/import/BulkImportModal";


function AgencyList() {
    const [selectedTab, setSelectedTab] = useState('first');
    const [tabCount, setTabCount] = useState({ activeCount: 0, inActiveCount: 0, inProgressCount: 0, rejectedCount: 0 })
    const [searchKeyword, setSearchKeyword] = useState("");
    const [selectedFilters, setSelectedFilters] = useState<any>({ activeTab: "first"});
    const {translations} = useLanguage();
    const navigate = useNavigate();
    const [bulkUploadModal, setBulkUploadModal] = useState<any>(false);
    let authUserInfo:any = secureStorage.getItem('authUserInfo');

    const handleTabSelect = (eventKey: any) => {
        setSelectedTab(eventKey);
    };

    const updateTabCount = (params: any) => {
        setTabCount(params)
    }

    /**
     * ON ENTER SEARCH 
     * @param event 
     */
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            setSearchKeyword(event?.target?.value?.trim())
        }
    }

    const updateListFromChlid = (filterParams: any) => {
        setSelectedFilters((prevFilters: any) => {
            let updatedFilters = { ...prevFilters };
    
            // Only delete reporting_to_name if it's not in filterParams
            if (!filterParams.hasOwnProperty('reporting_to_name')) {
                delete updatedFilters['reporting_to_name'];
                delete updatedFilters['reporting_to_name_label'];
            }
            // Return the updated filters with activeTab included
            return {
                ...updatedFilters,
                ...filterParams,
                activeTab: selectedTab,
            };
        });
    
        if (filterParams.hasOwnProperty('searchKeyword')) {
            setSearchKeyword(filterParams.searchKeyword);
        }
    };
    

    const resetFilters = () => {
        setSelectedFilters((prevFilters:any) => {
            const { activeTab, page_number } = prevFilters;
            return {
                activeTab: activeTab || selectedTab,
                page_number: page_number || PAGE_NUMBER
            };
        });
        setSearchKeyword("");
    }

    const onFilterChipRemove = (filterKey: string, filterVal: any) => {
        if(filterKey === "searchKeyword"){
            setSearchKeyword("");
        }
        setSelectedFilters((prevFilters:any) => {
            const updatedFilters = { ...prevFilters };
            delete updatedFilters[filterKey];
            return updatedFilters;
        });
    }

    /**
     * MAKE FILTER VALUES CHIPS
     * @returns 
     */
    const makeFilterChips = () => {
        let chipsHtml:any = [];
        if (Object.keys(selectedFilters).length) {
            for (let filterKey of Object.keys(selectedFilters)) {
                if(filterKey === "searchKeyword"){
                    chipsHtml.push(
                        <li key={filterKey}>
                            {selectedFilters[filterKey]}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }
                if (filterKey === "created_at") {
                    chipsHtml.push(
                        <li key={filterKey}>
                            Created Date: {selectedFilters[filterKey]}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }
                if (filterKey === "approval_date") {
                    chipsHtml.push(
                        <li key={filterKey}>
                            Approval Date: {selectedFilters[filterKey]}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }
                if (filterKey === "reporting_to_role") {
                    chipsHtml.push(
                        <li key={filterKey}>
                            Reporting To Role: {selectedFilters['reporting_to_role_label']}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }
                if (filterKey === "reporting_to_name") {
                    chipsHtml.push(
                        <li key={filterKey}>
                            Reporting To Name: {selectedFilters['reporting_to_name_label']}
                            <span onClick={() => onFilterChipRemove(filterKey, '')}>
                                <i className="ic-clearclose"></i>
                            </span>
                        </li>
                    );
                }
            }
        }
        return chipsHtml;
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="top-heading financer-lead-heding">
                    <h1>{translations.RuleEngine?.['Insurance Agency Management'] || translations.commonMsg?.loading}</h1>
                    <div className="d-flex">
                        {
                            HELPER.isUserHasAccessPage({
                                permissionID: ROLE_FEATURES['insurance_agency_partner_management'],
                                accessType: 'edit'
                            }) && (
                                <button className="btn-line m-sm-r" onClick={() => navigate(INS_INSURANCE_ID_STAGE? "/agency/add": "/agency/create")}>
                                    <i className="ic-add"></i>
                                    <span>{translations.RuleEngineAgency?.['Add Agent']}</span>
                                </button>
                            )
                        }
                        {
                            INS_INSURANCE_ID_STAGE && HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['bulk_upload_application'], accessType: 'edit', assignUserId: authUserInfo?.user_data?.id }) &&
                            <button className="btn-line m-sm-r" onClick={() => setBulkUploadModal(!bulkUploadModal)}>
                                <span>{translations.RuleEngineAgency?.['Bulk Upload Agent Data']}</span>
                            </button>
                        }
                    </div>
                </div>
                <div className="loan-filter-bg managment-tabs tab-chips">
                    {
                        INS_INSURANCE_ID_STAGE && 
                        <div className="top-filter-bg">
                            <AgencyListTopFilter submitHandler={(filterParams: any) => { updateListFromChlid(filterParams); }}  resetSort={resetFilters} resetSelectedFilters={selectedFilters}/>
                            <div className="selected-chips">
                                <ul>
                                    {
                                        makeFilterChips()
                                    }
                                </ul>
                            </div>
                        </div>
                    }
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <div className="p-rel">
                            <div className="role-management-top-sec">
                                <div className="selected-chips">
                                    <Nav variant="pills" className="flex-column tab-line nav nav-pills" onSelect={(k) => handleTabSelect(k)}>
                                        <div className="tab-list">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first" disabled={!tabCount?.activeCount}>{translations.commonMsg?.['active'] || translations.commonMsg?.loading}({tabCount?.activeCount})</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second" disabled={!tabCount?.inActiveCount}>{translations.commonMsg?.['in_active'] || translations.commonMsg?.loading}({tabCount?.inActiveCount}) </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third" disabled={!tabCount?.inProgressCount}>{translations.RuleEngineAgency?.['In_progress'] || translations.commonMsg?.loading}({tabCount?.inProgressCount})</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="forth" disabled={!tabCount?.rejectedCount}> {translations.RuleEngineAgency?.['Rejected'] || translations.commonMsg?.loading}({tabCount?.rejectedCount}) </Nav.Link>
                                            </Nav.Item>

                                        </div>

                                        {

                                            !INS_INSURANCE_ID_STAGE && HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit' }) &&
                                            <>
                                                <div className="btn-submit-reset">
                                                    <fieldset className="search-bx">
                                                        <div className="material">
                                                            <input id="Search" type="text" title="Search by agent id, agent name, email, mobile" placeholder="Search by agent id, agent name, email, mobile" onChange={(e: any) => (e)}  className="form-input" onKeyDown={handleKeyDown}/>
                                                            <i className="ic-search"></i>
                                                        </div>
                                                    </fieldset>


                                                  
                                                </div>
                                            </>
                                        }
                                    </Nav>
                                </div>

                                <AgencyListTable updateTabCount={updateTabCount} activeTab={selectedTab} searchKeyword={searchKeyword} selectedFilters={selectedFilters}/>


                            </div>
                        </div>

                    </Tab.Container>
                </div>
                  {
                    bulkUploadModal
                    &&
                    <div className={`calculator-popup davition-popup bulk-upload-popup`}>
                        <Modal show={bulkUploadModal} handleClose={() => setBulkUploadModal(false)} >
                            <div className="modal-header">
                                    <h2>
                                        {INS_INSURANCE_ID_STAGE ? translations.RuleEngineAgency?.['Bulk Upload Agent Data'] : translations.RuleEngineAgency?.['Bulk Upload Application']}
                                    </h2>
                            </div>
                            <div className="modal-body" >
                                <div className="bulk-upload-history-content">
                                    <BulkImportModal setUpdateModal={{setUpdateModal:bulkUploadModal, type:"bulk_upload", title: "Bulk Upload Application"}} type="uploadID" closeBulkUploadModal={()=>setBulkUploadModal(false)}/>
                                    
                                </div>
                            </div>
                        </Modal>
                    </div>
                }

            </div>
        </React.Fragment>
    )
}

export default AgencyList